import { render, staticRenderFns } from "./instance-gis.vue?vue&type=template&id=0a052c7a&scoped=true"
import script from "./instance-gis.vue?vue&type=script&lang=js"
export * from "./instance-gis.vue?vue&type=script&lang=js"
import style0 from "./instance-gis.vue?vue&type=style&index=0&id=0a052c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a052c7a",
  null
  
)

export default component.exports